import { SegmentSettings } from '@fullstory/proto/fs/services/search-settings/visualizationsettings';
import { int64 } from '@fullstory/proto/google/protobuf';
import { SegmentsInfo } from '../types';
import { intl } from '@fullstory/intl';

export const REQUIRED_FIELD_STRING = intl.formatMessage({
  defaultMessage: 'This field is required.',
  id: '6B5Jtu',
});
export const validateRequiredField = (value: string | string[] | SegmentSettings[]) => {
  if (!value || value.length == 0) return REQUIRED_FIELD_STRING;
  return null;
};
export const validateRequiredInt64 = (value: int64) => {
  if (!value) return REQUIRED_FIELD_STRING as int64;
  return null;
};

const SEGMENT_DELETED = intl.formatMessage({
  defaultMessage: 'Segment no longer exists.',
  id: 'GQJvPF',
});
export const isSegmentDeletedError = (error: string) => error === SEGMENT_DELETED;

export const validateSegmentSettings = (
  s: SegmentSettings | SegmentSettings[],
  state: SegmentsInfo,
) => {
  const validate = (ss: SegmentSettings) => {
    if (!ss.segmentId && !ss.segmentDefinition && !ss.namedSegmentDefinition) {
      return REQUIRED_FIELD_STRING;
    }
    if (ss.segmentId && !state.segmentsLoading && !state.segmentsById[ss.segmentId]) {
      return SEGMENT_DELETED;
    }
    return null;
  };

  if (Array.isArray(s)) {
    if (!s?.length) return REQUIRED_FIELD_STRING;
    for (const ss of s) {
      const error = validate(ss);
      if (error) return error;
    }
    return null;
  }

  return validate(s);
};
